import React from 'react';
import Indicator from "components/modal/dataModal/data/modaljustify/address/component/indicator";
import Firstform from "components/modal/dataModal/data/modaljustify/address/component/body/firstform";
import Secondform from "components/modal/dataModal/data/modaljustify/address/component/body/secondform";
import Threeform from "components/modal/dataModal/data/modaljustify/address/component/body/threeform";
import HostIdentityForm from "components/modal/dataModal/data/modaljustify/address/component/body/hostIdentityForm";
import CheckFilesIdentity from "../../identity/components/body/checkFilesIdentity";

const Multiform = ({formIndex, setFormIndex, setCheck, setProof, proof, attestation, setAttestation, check, hostIdentity, setHostIdentity, onModifyAll}) => {

    const elements = [
        <Firstform single={setProof} />,
        <CheckFilesIdentity key="check-proof-single" files={[proof]} />,
    ]

    // Steps: 1-Proof, 2-CheckProof, 3-Attestation, 4-CheckAttestation,
    // 5-HostIdentity, 6-CheckHostIdentity, 7-Recap
    const elements2 = [
        <Firstform single={setProof} />,
        <CheckFilesIdentity key="check-proof" files={[proof]} />,
        <Secondform attest={setAttestation} />,
        <CheckFilesIdentity key="check-attestation" files={[attestation]} />,
        <HostIdentityForm hostIdentity={hostIdentity} setHostIdentity={setHostIdentity} />,
        <CheckFilesIdentity key="check-host-id" files={[hostIdentity.fileR, hostIdentity.fileV].filter(Boolean)} />,
        <Threeform onModifyAll={onModifyAll} />,
    ]


    return (
        <>
            {
                !check && (
                    <Indicator formIndex={formIndex}/>
                )
            }
            {
                formIndex === 7 ? (
                    <Threeform onModifyAll={onModifyAll} />
                ) : check ? (
                    <>
                        {elements.map((item, index) => {
                            if((index + 1) === formIndex){
                                return elements[index]
                            }
                        })}
                    </>
                ) : (
                    <>
                        {elements2.map((item, index) => {
                            if((index + 1) === formIndex){
                                return elements2[index]
                            }
                        })}
                    </>
                )
            }
        </>
    );
};

export default Multiform;